<template>
	<div>
		<v-dialog v-model="dialog_addons" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">

        	<v-card>
        		<v-toolbar flat>
				    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				    <v-toolbar-title class="white--text">{{addOnsProp.toolbarTitle}}</v-toolbar-title>

				    <v-spacer></v-spacer>

				    <v-btn round-borders outline @click="fn_checkValidations">Done</v-btn>
				</v-toolbar>
        		<!-- <v-divider></v-divider> -->
        	  	<v-card-text full-height nopadding grey-back>
        	  		<v-form data-vv-scope="fields" full-width>
        	  			<v-layout wrap padding-top-bottom-ten white-background>

							<v-flex xs12 sm12 md12 form-item
					        	@click="fn_openAddOnsList">

				               <v-text-field  
					               	readonly
					               	v-model="$parent.Form.addOnsDataModel.name" 
					               	label="Name" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	:onUpdate="fn_updateAddOns"
					               	ref="ref_dialogAddOns_name"
					               	v-validate="'required'" 
				               		data-vv-name="name" 
				               		:error-messages="errors.collect('fields.name')"
				               		required>
				               </v-text-field>
				            </v-flex>

				            <v-flex xs12 sm12 md12 form-item v-if="$parent.Form.addOnsDataModel.mode==0">
				               <v-text-field  
					           		v-model.number="$parent.Form.addOnsDataModel.percentage"
					           		label="Percentage" 
					           		placeholder=" "
					           		type="number"
					           		v-validate="'min_value:0|decimal:2'" 
				               		data-vv-name="percentage" 
				               		:error-messages="errors.collect('fields.percentage')">
					           	</v-text-field>
				            </v-flex>

				            <v-flex xs12 sm12 md12 form-item v-else>
				               <v-text-field  
					           		v-model.number="$parent.Form.addOnsDataModel.value"
					           		label="Value" 
					           		placeholder=" "
					           		type="number"
					           		v-validate="'min_value:0|decimal:2'" 
				               		data-vv-name="value" 
				               		:error-messages="errors.collect('fields.value')">
					           	</v-text-field>
				            </v-flex>
<!-- 
				            <v-flex xs12 sm12 md12 form-item v-else>
				               <v-text-field  
					           		v-model.number="$parent.Form.addOnsDataModel.value"
					           		:label="$parent.Form.addOnsDataModel.mode ? 'Value' : 'Percentage'" 
					           		placeholder=" "
					           		type="number"
					           		v-validate="'min_value:0|decimal:2'" 
				               		data-vv-name="value" 
				               		:error-messages="errors.collect('fields.value')">
					           	</v-text-field>
				            </v-flex> -->

						</v-layout>


						<v-expansion-panel margin-top-ten>
						    <v-expansion-panel-content>
						    <v-subheader slot="header" nopadding>Advance Properties</v-subheader>
						    
						    <v-layout row wrap white-background v-if="$parent.Form.addOnsDataModel.mode==0">

						    	<v-subheader full-width border-bottom-thin>% of Value</v-subheader>

						        <v-flex xs12 sm12 md12 form-item>
					               	<v-radio-group v-model="$parent.Form.addOnsDataModel.appliedOn" row>
								      <v-radio label="Net Value" :value="0"></v-radio>
								      <v-radio label="Value of Goods" :value="1"></v-radio>
								      <!-- <v-radio label="MRP" :value="2"></v-radio> -->
								    </v-radio-group>
					            </v-flex>

					        </v-layout>

					        <!-- <v-divider></v-divider>

					        <v-layout row wrap>
					          	<v-flex xs12 sm12 md12 form-item>
					               	<v-checkbox label="Adjust in Total" right-align-checkbox v-model="$parent.Form.addOnsDataModel.adjustInTotal"></v-checkbox>
					            </v-flex>
					        </v-layout> -->
						    </v-expansion-panel-content>
						</v-expansion-panel>


						
        	  		</v-form>
        	  		
        	  	</v-card-text>
	        </v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>
const menuItem = require('../../config.js').configs.menuItem;
const fixedGstAddOns = require('../../config.js').configs.fixedGstAddOns;
const fixedCessAddOns = require('../../config.js').configs.fixedCessAddOns;

export default{
	props:['openAddOnsList', 'addOnsProp', 'saveAddOns', 'type'],
	data(){	
		return{
			dialog_addons: false,
			addOnsData:null
			// addOnsTitle:null,
			// addOnsData:{"addOnsId":null, "name":null, "value":null, "appliedOn":null, "adjustInTotal":true},
		}
	},
	methods:{
		openDialogWeb: function () {
			// this.addOnsType == 'discounts' ? this.addOnsTitle = "Discounts" :  this.addOnsType == 'taxes' ? this.addOnsTitle = "Taxes" :  this.addOnsTitle = "Other Charges";
			this.dialog_addons = true;
		},
		closeDialogWeb: function () {
			this.dialog_addons = false;
		},
		fn_openAddOnsList: function () {
			this.openAddOnsList('android', 'AddOns', 'ref_dialogAddOns_name', this.$parent.Form.addOnsDataModel.addOnsId, this.$parent.Form.addOnsDataModel.name, this.addOnsProp.addOnsType);
		},
		fn_updateAddOns: function (selectedValueId, selectedValueName, isRemoved) {
			if(!isRemoved){
				if((this.$root.CurrentBusiness.GSTRegistrationStatus!=1 && this.type && this.type=='sale') && (selectedValueId == fixedGstAddOns.CGST.id || selectedValueId == fixedGstAddOns.SGST.id || selectedValueId == fixedGstAddOns.IGST.id || selectedValueId == fixedGstAddOns.UTGST.id || selectedValueId == fixedCessAddOns.CESS.id)){
					this.showToast("Not applicable for this transaction");
				}
				else if(this.$parent.Form.gstType == "IntraState" && (selectedValueId == fixedGstAddOns.IGST.id || selectedValueId == fixedGstAddOns.UTGST.id)){
					this.showToast("Not applicable for this transaction");
				}
				else if(this.$parent.Form.gstType == "UnionTerritory" && (selectedValueId == fixedGstAddOns.IGST.id || selectedValueId == fixedGstAddOns.SGST.id)){
					this.showToast("Not applicable for this transaction");
				}
				else if(this.$parent.Form.gstType == "InterState" && (selectedValueId == fixedGstAddOns.CGST.id || selectedValueId == fixedGstAddOns.SGST.id || selectedValueId == fixedGstAddOns.UTGST.id)){
					this.showToast("Not applicable for this transaction");
				}
				else{
					this.$parent.Form.addOnsDataModel.addOnsId = selectedValueId;
		        	this.$parent.Form.addOnsDataModel.name = selectedValueName;
		        	this.addOnsData = null;
		        	this.fn_get(selectedValueId);
				}
			}
			else{
				this.$parent.Form.addOnsDataModel.addOnsId = null;
	        	this.$parent.Form.addOnsDataModel.name = null;
			}
		},
		fn_get: function(itemId){
			var self = this;
			this.getData('AddOns', itemId, 
				{
					onSuccess: function(response){
						console.log(response);
						self.addOnsData = JSON.parse(response);
						self.$parent.Form.addOnsDataModel.mode = self.addOnsData.mode;
						self.$parent.Form.addOnsDataModel.nature = self.addOnsData.nature;
						self.$parent.Form.addOnsDataModel.addOnsType = self.addOnsData.addonGroupId;

						self.$parent.Form.addOnsDataModel.purchaseAccountItemId = self.addOnsData.purchaseAccountItemId;
						self.$parent.Form.addOnsDataModel.saleAccountItemId = self.addOnsData.saleAccountItemId;

						self.$parent.fn_openDialogAddons ? self.$parent.fn_openDialogAddons() : '';
			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				}
	        );
		},
		fn_checkValidations: function(){
			this.$validator.validateAll('fields').then((result) => {
		        if (result) {
		        	this.$parent.Form.addOnsDataModel.percentage === "" ? this.$parent.Form.addOnsDataModel.percentage = null : '';
		        	this.$parent.Form.addOnsDataModel.value === "" ? this.$parent.Form.addOnsDataModel.value = null : '';
		        	this.saveAddOns(this.$parent.Form.addOnsDataModel);
		        }
		    });
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_addons.vue